import { useCallback, useEffect, useState } from "react";
import { vinosApi } from "../api/vinosApi";

export function useVinosData() {
    const [vinos, setVinos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const reload = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const data = await vinosApi.listAll();
            setVinos(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(e?.message || "Error cargando vinos");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        reload();
    }, [reload]);

    return { vinos, loading, error, reload };
}
